import {
  Actions,
  Box,
  ButtonLink,
  ContentBlock,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';

import { PageWrapper } from '#src/components/PageWrapper/PageWrapper';

export const NotFound = () => (
  <PageWrapper>
    <ContentBlock>
      <Box paddingY="xlarge" paddingX={{ mobile: 'gutter', tablet: 'none' }}>
        <Stack space="large">
          <Heading level="1">Page not found</Heading>
          <Text>
            Sorry, we couldn&apos;t find that page. It may have moved or no
            longer exists.
          </Text>
          <Actions>
            <ButtonLink href="/" tone="formAccent">
              Back to home
            </ButtonLink>
          </Actions>
        </Stack>
      </Box>
    </ContentBlock>
  </PageWrapper>
);
